"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('hand-right', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M10.0266 40.9736L10.0266 18.9736H4.02655L4.02655 40.9736H10.0266Z",
    fill: props.outFillColor,
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0266 18.9738C17.1495 12.4548 21.2774 8.71418 22.4103 7.75192C24.1098 6.30854 26.0305 6.91463 26.0305 10.5268C26.0305 14.139 20.7451 16.2222 20.7451 18.9738C20.7417 18.9902 27.5008 18.9913 41.0225 18.9771C42.6799 18.9753 44.0248 20.3174 44.0265 21.9748L44.0266 21.9779C44.0266 23.6371 42.6815 24.9821 41.0224 24.9821H33.0129C31.8041 32.9549 31.1372 37.2894 31.0122 37.9858C30.8246 39.0303 29.8276 40.9738 26.9585 40.9738C25.0458 40.9738 20.0685 40.9738 10.0266 40.9738V18.9738Z",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinejoin: props.strokeLinejoin
  }));
});

exports.default = _default;